/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import Dropdown from "./dropdown";
import Footer from "./footer";
import SoftSelect from "components/SoftSelect";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";

import { v4 as uuidV4 } from "uuid";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const Th = ({ children, style, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "15px" }}>
      {children}
    </th>
  );
};
const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style, fontSize: "14px" }}>
      {children}
    </th>
  );
};

const provinceOption = [
  {
    value: "An giang",
    label: "An giang",
  },
  {
    value: "Cần thơ",
    label: "Cần thơ",
  },
  {
    value: "TP Hồ Chí Minh",
    label: "TP Hồ Chí Minh",
  },
];

const districtOption = [
  {
    value: "Châu thành",
    label: "Châu thành",
  },
  {
    value: "Long xuyên",
    label: "Long xuyên",
  },
  {
    value: "Chợ mới",
    label: "Chợ mới",
  },
];

const taxAuthoritiesOption = [
  {
    value: "Cục thuế TP.HCM",
    label: "Cục thuế TP.HCM",
  },
  {
    value: "Cục thuế An giang",
    label: "Cục thuế An giang",
  },
];
const typeOption = [
  {
    value: "Nơi có văn phòng điều hành nhà máy",
    label: "Nơi có văn phòng điều hành nhà máy",
  },
  {
    value: "Nơi có nhà máy thủy điện",
    label: "Nơi có nhà máy thủy điện",
  },
];

const dataTable = [
  {
    onlyTitle: true,
    bold: true,
    id: {
      value: uuidV4(),
      bg: true,
    },
    type: {
      type: "select",
      value: null,
      bg: false,
      option: typeOption,
    },
    companyName: {
      type: "input",
      value: null,
      bg: false,
    },
    taxID: {
      type: "input",
      value: null,
      bg: false,
    },
    province: {
      type: "select",
      value: null,
      bg: false,
      option: provinceOption,
    },
    district: {
      type: "select",
      value: null,
      bg: false,
      option: districtOption,
    },
    mainTaxAuthorities: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    subTaxAuthorities: {
      type: "select",
      value: null,
      bg: false,
      option: taxAuthoritiesOption,
    },
    taxMusBePaid: {
      type: "input",
      value: 0,
      bg: false,
    },
    percent: {
      type: "input",
      value: 0,
      bg: false,
    },
    taxMusBePaidForProvince: {
      type: "input",
      value: 0,
      bg: false,
    },
  },
];

export default function AppendixTable({ formData, setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id.value === id) {
          return { ...item, [name]: { ...item[name], value } };
        }
        return item;
      })
    );
  };

  const addNewRow = () => {
    // const newIdValue = getMaxIdValue() + 1;
    const newRow = {
      onlyTitle: true,
      bold: true,
      id: {
        value: uuidV4(),
        bg: true,
      },
      type: {
        type: "select",
        value: null,
        bg: false,
        option: typeOption,
      },
      companyName: {
        type: "input",
        value: null,
        bg: false,
      },
      taxID: {
        type: "input",
        value: null,
        bg: false,
      },
      province: {
        type: "select",
        value: null,
        bg: false,
        option: provinceOption,
      },
      district: {
        type: "select",
        value: null,
        bg: false,
        option: districtOption,
      },
      mainTaxAuthorities: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      subTaxAuthorities: {
        type: "select",
        value: null,
        bg: false,
        option: taxAuthoritiesOption,
      },
      taxMusBePaid: {
        type: "input",
        value: 0,
        bg: false,
      },
      percent: {
        type: "input",
        value: 0,
        bg: false,
      },
      taxMusBePaidForProvince: {
        type: "input",
        value: 0,
        bg: false,
      },
    };
    setData((prev) => [...prev, newRow]);
  };

  const removeRow = () => {
    if (data.length !== 1) {
      data.pop();
      const newRow = data;
      setData([...newRow]);
    }
  };

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex" justifyContent="flex-end">
        <Typography variant="subtitle1" fontSize={14} fontStyle="italic">
          Đơn vị tiền: Đồng Việt Nam
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <thead>
            <tr>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                STT
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Loại
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tên nhà máy thủy điện theo từng tỉnh
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Mã số thuế/Mã địa điểm kinh doanh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Địa bàn hoạt động sản xuất, kinh doanh
              </Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                Cơ quan thuế quản lý địa bàn nhận phân bố
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số thuế tài nguyên phải nộp của nhà máy thủy điện
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Tỷ lệ phân bố(%)
              </Th>
              <Th style={{ textAlign: "center" }} rowSpan="2">
                Số thuế phải nộp cho từng tỉnh
              </Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>Tỉnh</Th>
              <Th style={{ textAlign: "center" }}>Huyện</Th>
              <Th style={{ textAlign: "center" }}>Cơ quan thuế quản lý cấp cục</Th>
              <Th style={{ textAlign: "center" }}>Cơ quan thuế quản lý cấp chi cục</Th>
            </tr>
            <tr>
              <Th style={{ textAlign: "center" }}>(04)</Th>
              <Th style={{ textAlign: "center" }}></Th>
              <Th style={{ textAlign: "center" }}>(05)</Th>
              <Th style={{ textAlign: "center" }}>(06)</Th>
              <Th style={{ textAlign: "center" }}>(07)</Th>
              <Th style={{ textAlign: "center" }}>(08)</Th>
              <Th style={{ textAlign: "center" }} colSpan="2">
                (09)
              </Th>
              <Th style={{ textAlign: "center" }}>(10)</Th>
              <Th style={{ textAlign: "center" }}>(11)</Th>
              <Th style={{ textAlign: "center" }}>(12)=(11)x(10)</Th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              >
                1
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#fff",
                }}
              >
                <InputTable id={"total"} type={"text"} name="total" disable={false} />
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#fff",
                }}
              >
                <InputTable id={"total"} type={"text"} name="total" disable={false} />
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#fff",
                }}
              >
                <InputTable id={"total"} type={"number"} name="total" value={0} disable={false} />
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable id={"total"} type={"number"} name="total" value={0} disable={true} />
              </Td>
            </tr>

            {data &&
              data.length > 0 &&
              data.map((row, index) => (
                <tr key={row.id.value + index}>
                  <Td
                    row={""}
                    style={{
                      textAlign: "center",
                      background: "transparent",
                    }}
                  >
                    {index < 1 ? 1 + 0.1 : index === 1 ? 1 + 0.2 : 1 + 0.1 * (index + 1)}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.type.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.type.bg ? (
                      row.type.value
                    ) : row.type?.type === "select" ? (
                      <SelectTable
                        name="type"
                        id={row.id.value}
                        option={row.type.option ? row.type.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="type"
                        value={row.type.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.companyName.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.companyName?.type !== "input" ? (
                      row.companyName.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="companyName"
                        value={row.companyName.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxID.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxID?.type !== "input" ? (
                      row.taxID.value
                    ) : (
                      <InputTable
                        type={"text"}
                        id={row.id.value}
                        name="taxID"
                        value={row.taxID.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.province.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.province.bg ? (
                      row.province.value
                    ) : row.province?.type === "select" ? (
                      <SelectTable
                        name="province"
                        id={row.id.value}
                        option={row.province.option ? row.province.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="province"
                        value={row.province.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.district.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.district.bg ? (
                      row.district.value
                    ) : row.district?.type === "select" ? (
                      <SelectTable
                        name="district"
                        id={row.id.value}
                        option={row.district.option ? row.district.option : defaultOption}
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="district"
                        value={row.district.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.mainTaxAuthorities.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.mainTaxAuthorities.bg ? (
                      row.mainTaxAuthorities.value
                    ) : row.mainTaxAuthorities?.type === "select" ? (
                      <SelectTable
                        name="mainTaxAuthorities"
                        id={row.id.value}
                        option={
                          row.mainTaxAuthorities.option
                            ? row.mainTaxAuthorities.option
                            : defaultOption
                        }
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="mainTaxAuthorities"
                        value={row.mainTaxAuthorities.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "left",
                      background: !row.subTaxAuthorities.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.subTaxAuthorities.bg ? (
                      row.subTaxAuthorities.value
                    ) : row.subTaxAuthorities?.type === "select" ? (
                      <SelectTable
                        name="subTaxAuthorities"
                        id={row.id.value}
                        option={
                          row.subTaxAuthorities.option
                            ? row.subTaxAuthorities.option
                            : defaultOption
                        }
                        onSelect={handleChange}
                      />
                    ) : (
                      <InputTable
                        id={row.id.value}
                        name="subTaxAuthorities"
                        value={row.subTaxAuthorities.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxMusBePaid.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxMusBePaid?.type !== "input" ? (
                      row.taxMusBePaid.value
                    ) : (
                      <InputTable
                        type={"number"}
                        id={row.id.value}
                        name="taxMusBePaid"
                        value={row.taxMusBePaid.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.percent.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.percent?.type !== "input" ? (
                      row.percent.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        type={"number"}
                        name="percent"
                        value={row.percent.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>

                  <Td
                    row={row}
                    style={{
                      textAlign: "right",
                      background: !row.taxMusBePaidForProvince.bg ? "transparent" : "#ddeff3",
                    }}
                  >
                    {row.taxMusBePaidForProvince?.type !== "input" ? (
                      row.taxMusBePaidForProvince.value
                    ) : (
                      <InputTable
                        id={row.id.value}
                        type={"number"}
                        name="taxMusBePaidForProvince"
                        value={row.taxMusBePaidForProvince.value}
                        onChange={handleChange}
                      />
                    )}
                  </Td>
                </tr>
              ))}

            <tr>
              <Td
                colSpan="8"
                row={{ bold: true }}
                style={{
                  textAlign: "center",
                  // paddingRight: "78px",
                  background: "#ddeff3",
                }}
              >
                Cộng([13]=
                <span style={{ display: "inline-block", transform: "rotate(-90deg)" }}>M</span>
                [10]; [14]=
                <span style={{ display: "inline-block", transform: "rotate(-90deg)" }}>M</span>[12])
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={"total"}
                  type={"number"}
                  name="total"
                  value={0}
                  disable={true}
                  // onChange={handleChange}
                />
              </Td>
              <Td
                colSpan="1"
                row={{ bold: true }}
                style={{
                  textAlign: "right",
                  background: "#ddeff3",
                }}
              ></Td>
              <Td
                style={{
                  textAlign: "left",
                  // paddingRight: "78px",
                  background: "#ddeff3",
                }}
              >
                <InputTable
                  id={"total"}
                  type={"number"}
                  name="total"
                  value={0}
                  disable={true}
                  // onChange={handleChange}
                />
              </Td>
            </tr>
          </tbody>
        </table>
        <SoftBox display="flex" justifyContent="flex-start" gap={3} mt={2}>
          <SoftButton variant="gradient" color="dark" onClick={addNewRow}>
            Thêm dòng
          </SoftButton>
          <SoftButton variant="gradient" color="light" onClick={removeRow}>
            Xóa dòng
          </SoftButton>
        </SoftBox>
        <Footer formData={formData} />
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { id, onChange, type, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;
  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value;
    if (type == "number") {
      if (!regexNumber.test(newValue)) return;
      onChange({ id, value: newValue !== "" ? +newValue : "", name, type });
    } else if (type == "decimal") {
      if (!regexDecimal.test(newValue)) return;
      onChange({ id, value: newValue, name, type });
    } else {
      onChange({ id, value: newValue !== "" ? newValue : "", name, type });
    }
  }
  return (
    <input
      type="text"
      style={{
        textAlign: type === "number" ? "right" : "left",
        fontSize: 16,
        color: "#344767",
        border: "none",
        background: "transparent",
        padding: "4px 4px 4px 4px",
        width: "100%",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}

function SelectTable(props) {
  const { id, onSelect, type, option, name, style, ...rest } = props;
  const [newValue, setNewValue] = useState();
  useEffect(() => {
    if (typeof onSelect === "function") {
      onSelect({ id, value: newValue !== "" ? newValue : "", name, type });
    }
  }, [newValue]);
  return (
    <div style={style}>
      <Dropdown option={option} id={id} newValue={newValue} setNewValue={setNewValue} />
    </div>
  );
}
